// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@keyframes rotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.loader2 {
  display: flex;
  justify-content: center;
}
.loader2__container {
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
}
.loader2__film {
  position: absolute;
  top: -30px;
  left: 0;
  display: flex;
}
.loader2__film-img {
  animation: rotate 1s linear infinite;
}

.cctv__requests {
  min-height: 90vh;
}
.cctv__requests .cctv-header {
  margin: 0;
  margin-bottom: 1vh;
  text-align: left;
  padding: 0 2vw;
  background-image: linear-gradient(to left, #fff, #2c53a0);
  color: #fff;
  position: sticky;
  margin-left: 10vw;
  width: 85%;
  text-transform: none;
}
@media (max-width: 1000px) {
  .cctv__requests .cctv-header {
    font-size: 1.5rem;
  }
}
@media (max-width: 600px) {
  .cctv__requests .cctv-header {
    font-size: 1.2rem;
  }
}
.cctv__requests .filter-section .status-filter {
  margin-bottom: 10px;
  border-radius: 5px;
  padding: 0 5px;
  height: 4vh;
}
.cctv__requests .drive-off-search input {
  margin-bottom: 10px;
  border-radius: 5px;
  padding: 0 5px;
  height: 4vh;
}
.cctv__requests .drive-off-search button {
  padding: 0 5px;
  height: 4vh;
  margin-left: 1vw;
}
.cctv__requests .drive-off-search select {
  margin-bottom: 10px;
  border-radius: 5px;
  padding: 0 5px;
  height: 4vh;
  margin-right: 1vw;
}
.cctv__requests .drive-off-search p {
  background-color: #2c53a0;
  padding: 5px;
  border-radius: 5px;
  margin-left: 5vw;
  color: #fff;
}
.cctv__requests .cctv-dev-table-container {
  overflow-y: auto;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  margin-left: 10vw;
  width: 85%;
}
.cctv__requests .cctv-dev-table-container .cctv__table {
  width: 100%;
  font-size: 0.9em;
  font-family: sans-serif;
}
.cctv__requests .cctv-dev-table-container .cctv__table thead {
  height: 4vh;
}
.cctv__requests .cctv-dev-table-container .cctv__table thead tr {
  background-color: #2c53a0;
  color: #ffffff;
  text-align: left;
}
.cctv__requests .cctv-dev-table-container .cctv__table thead tr th {
  text-align: center;
}
.cctv__requests .cctv-dev-table-container .cctv__table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.cctv__requests .cctv-dev-table-container .cctv__table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.cctv__requests .cctv-dev-table-container .cctv__table tbody tr:first-of-type {
  border-top: 2px solid #2c53a0;
}
.cctv__requests .cctv-dev-table-container .cctv__table tbody tr:last-of-type {
  border-bottom: 2px solid #2c53a0;
}
.cctv__requests .cctv-dev-table-container .cctv__table tbody tr td {
  text-align: center;
  padding: 12px 15px;
  word-wrap: break-word;
  color: black;
  font-size: 1rem;
  font-weight: 500;
}
.cctv__requests .cctv-dev-table-container .cctv__table tbody tr td .input_number {
  border-radius: 3px;
  border: 2px solid #2c53a0;
  width: 50px;
  height: 3vh;
  text-align: center;
}
.cctv__requests .cctv-dev-table-container .cctv__table tbody tr td input::-webkit-outer-spin-button,
.cctv__requests .cctv-dev-table-container .cctv__table tbody tr td input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.cctv__requests .cctv-dev-table-container .cctv__table tbody tr td .info-icon {
  cursor: pointer;
}
.cctv__requests .cctv-dev-table-container .cctv__table tbody tr .status-cell {
  display: flex;
  flex-direction: column;
}
.cctv__requests .cctv_row {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.cctv__requests .cctv_row input {
  border: 1px solid #2c53a0;
  border-radius: 0.5rem;
}
@media (max-width: 600px) {
  .cctv__requests {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .cctv__requests .cctv__cards {
    width: 80vw !important;
    margin-bottom: 2%;
    /* Hide table headers (but not display: none;, for accessibility) */
    /*
    Label the data
    */
  }
  .cctv__requests .cctv__cards table,
  .cctv__requests .cctv__cards thead,
  .cctv__requests .cctv__cards tbody,
  .cctv__requests .cctv__cards th,
  .cctv__requests .cctv__cards tr {
    display: block;
  }
  .cctv__requests .cctv__cards table {
    border: none;
  }
  .cctv__requests .cctv__cards h3 {
    text-align: center;
  }
  .cctv__requests .cctv__cards thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .cctv__requests .cctv__cards tr {
    margin-bottom: 3%;
  }
  .cctv__requests .cctv__cards th {
    /* Behave  like a "row" */
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    border: 1px solid black;
  }
  .cctv__requests .cctv__cards th:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
  }
  .cctv__requests .cctv__cards th:nth-of-type(1):before {
    content: "Date/Time";
  }
  .cctv__requests .cctv__cards th:nth-of-type(2):before {
    content: "Requester";
  }
  .cctv__requests .cctv__cards th:nth-of-type(3):before {
    content: "Reason";
  }
  .cctv__requests .cctv__cards th:nth-of-type(4):before {
    content: "Status";
  }
  .cctv__requests .cctv__cards th:nth-of-type(5):before {
    content: "Description";
  }
  .cctv__requests .cctv__cards th:nth-of-type(6):before {
    content: "Notes";
  }
}

.modal__tables {
  color: "#4d4d4d";
  border: "1px solid #4d4d4d";
  border-collapse: "collapse";
  width: "100%";
  table-layout: "fixed";
}
.modal__tables td {
  text-align: center;
}
.modal__tables tr:nth-child(even) {
  background-color: #f2f2f2;
}
@media (max-width: 600px) {
  .modal__tables tbody tr td {
    word-break: break-all;
  }
}

.driveoffRequests {
  height: 80vh;
}
.driveoffRequests #content .overlay {
  --border-style: 3px solid red;
  --border-space: 20px;
  margin-left: -40%;
  position: absolute;
  width: 88vw;
  height: 80vh;
}
.driveoffRequests #content .overlay-helper {
  position: relative;
  width: 100%;
  height: 100%;
}
.driveoffRequests #content .overlay-element {
  padding: 20px;
  width: 150px;
  height: 100px;
  position: absolute;
}
.driveoffRequests #content .overlay-text {
  font-size: 1.75em;
  color: black;
  font-family: monospace;
}
.driveoffRequests #content .overlay .top-left {
  border-left: var(--border-style);
  border-top: var(--border-style);
  top: var(--border-space);
  left: var(--border-space);
  text-align: left;
}
.driveoffRequests #content .overlay .top-right {
  border-right: var(--border-style);
  border-top: var(--border-style);
  top: var(--border-space);
  right: var(--border-space);
  text-align: right;
}
.driveoffRequests #content .overlay .bottom-left {
  border-left: var(--border-style);
  border-bottom: var(--border-style);
  bottom: var(--border-space);
  left: var(--border-space);
  text-align: left;
}
.driveoffRequests #content .overlay .bottom-right {
  border-right: var(--border-style);
  border-bottom: var(--border-style);
  bottom: var(--border-space);
  right: var(--border-space);
  text-align: right;
}
.driveoffRequests #content #overlay-bottom-left-text {
  position: absolute;
  bottom: var(--border-space);
  left: var(--border-space);
}
.driveoffRequests #content #overlay-bottom-right-text {
  position: absolute;
  bottom: var(--border-space);
  right: var(--border-space);
}
.driveoffRequests .all_modals input[type=text] {
  margin-bottom: 2%;
  border: 1px solid #2c53a0;
  border-radius: 0.5rem;
  background-color: #fff;
  width: 95%;
  padding: 1%;
}
.driveoffRequests .all_modals input[type=text] {
  margin-bottom: 2%;
  border: 1px solid #2c53a0;
  border-radius: 0.5rem;
  background-color: #fff;
  width: 95%;
  padding: 1%;
}

.pending_driveoff_notif {
  position: relative;
  top: -50px;
  right: -550px;
  text-align: center;
}

.pending_driveoff_notif :hover {
  cursor: pointer;
  border: 2px solid black;
}

.notif_sub_level {
  position: relative;
  display: inline-block;
}

.span_notif_sub {
  position: absolute;
  top: -10px;
  right: -25px;
  background: rgba(20, 47, 201, 0.85);
  color: white;
  border-block: 50%;
  padding: 2px 15px;
  font-size: 25px;
}

.highlighted-row {
  background-color: orange !important;
}

.pendingDriveoffModal {
  overflow-y: scroll;
  height: 80%;
}
.pendingDriveoffModal .DriveoffModalTableHead {
  background-color: rgb(231, 233, 236);
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/devZone/cctv/cctv.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAFA;EACI;IACI,oBAAA;EAIN;EADE;IACI,yBAAA;EAGN;AACF;AAAA;EACI,aAAA;EACA,uBAAA;AAEJ;AAAI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAER;AACI;EACI,kBAAA;EACA,UAAA;EACA,OAAA;EACA,aAAA;AACR;AAEI;EACI,oCAAA;AAAR;;AAIA;EACI,gBAAA;AADJ;AAEI;EACI,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yDAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,oBAAA;AAAR;AACQ;EAXJ;IAYQ,iBAAA;EAEV;AACF;AADQ;EAdJ;IAeQ,iBAAA;EAIV;AACF;AADQ;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;AAGZ;AAEQ;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;AAAZ;AAEQ;EACI,cAAA;EACA,WAAA;EACA,gBAAA;AAAZ;AAGQ;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;AADZ;AAIQ;EACI,yBDtFA;ECuFA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAFZ;AAMI;EACI,gBAAA;EACA,qDAAA;EACA,iBAAA;EACA,UAAA;AAJR;AAKQ;EACI,WAAA;EACA,gBAAA;EACA,uBAAA;AAHZ;AAKY;EACI,WAAA;AAHhB;AAIgB;EACI,yBD3GR;EC4GQ,cAAA;EACA,gBAAA;AAFpB;AAGoB;EACI,kBAAA;AADxB;AAOgB;EACI,gCAAA;AALpB;AAOoB;EACI,yBAAA;AALxB;AAOoB;EACI,6BAAA;AALxB;AAOoB;EACI,gCAAA;AALxB;AAQoB;EACI,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AANxB;AAOwB;EACI,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AAL5B;AAOwB;;EAEI,wBAAA;EACA,SAAA;AAL5B;AAQwB;EACI,eAAA;AAN5B;AAUoB;EACI,aAAA;EACA,sBAAA;AARxB;AAcI;ED3EA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;ACgEJ;AAUQ;EACI,yBAAA;EACA,qBAAA;AARZ;AAWI;EAvIJ;IAwIQ,sBAAA;IACA,uBAAA;IACA,mBAAA;EARN;EASM;IACI,sBAAA;IACA,iBAAA;IAiBA,mEAAA;IAgCA;;KAAA;EApDV;EAIU;;;;;IAKI,cAAA;EAFd;EAKU;IACI,YAAA;EAHd;EAMU;IACI,kBAAA;EAJd;EAQU;IACI,kBAAA;IACA,YAAA;IACA,aAAA;EANd;EASU;IACI,iBAAA;EAPd;EAUU;IACI,yBAAA;IACA,6BAAA;IACA,kBAAA;IACA,iBAAA;IACA,gBAAA;IACA,uBAAA;IACA,uBAAA;EARd;EAWU;IACI,4BAAA;IACA,kBAAA;IACA,kCAAA;IACA,QAAA;IACA,SAAA;IACA,UAAA;IACA,mBAAA;IACA,mBAAA;EATd;EAeU;IACI,oBAAA;EAbd;EAeU;IACI,oBAAA;EAbd;EAeU;IACI,iBAAA;EAbd;EAeU;IACI,iBAAA;EAbd;EAeU;IACI,sBAAA;EAbd;EAeU;IACI,gBAAA;EAbd;AACF;;AAkBA;EACI,gBAAA;EACA,2BAAA;EACA,2BAAA;EACA,aAAA;EACA,qBAAA;AAfJ;AAgBI;EACI,kBAAA;AAdR;AAiBQ;EACI,yBAAA;AAfZ;AAkBI;EAGY;IACI,qBAAA;EAlBlB;AACF;;AAwBA;EACI,YAAA;AArBJ;AAuBQ;EACI,6BAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AArBZ;AAwBQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AAtBZ;AAyBQ;EACI,aAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAvBZ;AA0BQ;EACI,iBAAA;EACA,YAAA;EACA,sBAAA;AAxBZ;AA2BQ;EACI,gCAAA;EACA,+BAAA;EACA,wBAAA;EACA,yBAAA;EACA,gBAAA;AAzBZ;AA4BQ;EACI,iCAAA;EACA,+BAAA;EACA,wBAAA;EACA,0BAAA;EACA,iBAAA;AA1BZ;AA6BQ;EACI,gCAAA;EACA,kCAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AA3BZ;AA8BQ;EACI,iCAAA;EACA,kCAAA;EACA,2BAAA;EACA,0BAAA;EACA,iBAAA;AA5BZ;AA+BQ;EACI,kBAAA;EACA,2BAAA;EACA,yBAAA;AA7BZ;AAgCQ;EACI,kBAAA;EACA,2BAAA;EACA,0BAAA;AA9BZ;AAmCQ;EACI,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;AAjCZ;AAsCQ;EACI,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;AApCZ;;AAyCA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;AAtCF;;AAwCA;EACE,eAAA;EACA,uBAAA;AArCF;;AAuCA;EACI,kBAAA;EACA,qBAAA;AApCJ;;AAsCA;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mCAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AAnCJ;;AAsCE;EACE,mCAAA;AAnCJ;;AAqCE;EACE,kBAAA;EACA,WAAA;AAlCJ;AAmCG;EACC,oCAAA;EACA,iBAAA;AAjCJ","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import \"../../variables.scss\";\n\n@keyframes rotate {\n    from {\n        transform: rotate(0);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.loader2 {\n    display: flex;\n    justify-content: center;\n\n    &__container {\n        position: relative;\n        display: flex;\n        align-items: center;\n        height: 40px;\n    }\n\n    &__film {\n        position: absolute;\n        top: -30px;\n        left: 0;\n        display: flex;\n    }\n\n    &__film-img {\n        animation: rotate 1s linear infinite;\n    }\n}\n\n.cctv__requests {\n    min-height: 90vh;\n    .cctv-header {\n        margin: 0;\n        margin-bottom: 1vh;\n        text-align: left;\n        padding: 0 2vw;\n        background-image: linear-gradient(to left, #fff, $nitroDark);\n        color: #fff;\n        position: sticky;\n        margin-left: 10vw;\n        width: 85%;\n        text-transform: none;\n        @media (max-width: 1000px) {\n            font-size: 1.5rem;\n        }\n        @media (max-width: 600px) {\n            font-size: 1.2rem;\n        }\n    }\n    .filter-section {\n        .status-filter {\n            margin-bottom: 10px;\n            border-radius: 5px;\n            padding: 0 5px;\n            height: 4vh;\n        }\n    }\n\n    .drive-off-search {\n        input {\n            margin-bottom: 10px;\n            border-radius: 5px;\n            padding: 0 5px;\n            height: 4vh;\n        }\n        button {\n            padding: 0 5px;\n            height: 4vh;\n            margin-left: 1vw;\n        }\n\n        select {\n            margin-bottom: 10px;\n            border-radius: 5px;\n            padding: 0 5px;\n            height: 4vh;\n            margin-right: 1vw;\n        }\n\n        p {\n            background-color: $nitroDark;\n            padding: 5px;\n            border-radius: 5px;\n            margin-left: 5vw;\n            color: #fff;\n        }\n    }\n\n    .cctv-dev-table-container {\n        overflow-y: auto;\n        box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n        margin-left: 10vw;\n        width: 85%;\n        .cctv__table {\n            width: 100%;\n            font-size: 0.9em;\n            font-family: sans-serif;\n            // table-layout: fixed;\n            thead {\n                height: 4vh;\n                tr {\n                    background-color: $nitroDark;\n                    color: #ffffff;\n                    text-align: left;\n                    th {\n                        text-align: center;\n                    }\n                }\n            }\n\n            tbody {\n                tr {\n                    border-bottom: 1px solid #dddddd;\n\n                    &:nth-of-type(even) {\n                        background-color: #f3f3f3;\n                    }\n                    &:first-of-type {\n                        border-top: 2px solid $nitroDark;\n                    }\n                    &:last-of-type {\n                        border-bottom: 2px solid $nitroDark;\n                    }\n\n                    td {\n                        text-align: center;\n                        padding: 12px 15px;\n                        word-wrap: break-word;\n                        color: black;\n                        font-size: 1rem;\n                        font-weight: 500;\n                        .input_number {\n                            border-radius: 3px;\n                            border: 2px solid $nitroDark;\n                            width: 50px;\n                            height: 3vh;\n                            text-align: center;\n                        }\n                        input::-webkit-outer-spin-button,\n                        input::-webkit-inner-spin-button {\n                            -webkit-appearance: none;\n                            margin: 0;\n                        }\n\n                        .info-icon {\n                            cursor: pointer;\n                        }\n                    }\n\n                    .status-cell {\n                        display: flex;\n                        flex-direction: column;\n                    }\n                }\n            }\n        }\n    }\n    .cctv_row {\n        @include rowEven;\n        input {\n            border: 1px solid $nitroDark;\n            border-radius: 0.5rem;\n        }\n    }\n    @media (max-width: $mobile) {\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        .cctv__cards {\n            width: 80vw !important;\n            margin-bottom: 2%;\n            table,\n            thead,\n            tbody,\n            th,\n            tr {\n                display: block;\n            }\n\n            table {\n                border: none;\n            }\n\n            h3 {\n                text-align: center;\n            }\n\n            /* Hide table headers (but not display: none;, for accessibility) */\n            thead tr {\n                position: absolute;\n                top: -9999px;\n                left: -9999px;\n            }\n\n            tr {\n                margin-bottom: 3%;\n            }\n\n            th {\n                /* Behave  like a \"row\" */\n                border-bottom: 1px solid #eee;\n                position: relative;\n                padding-left: 50%;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                border: 1px solid black;\n            }\n\n            th:before {\n                /* Now like a table header */\n                position: absolute;\n                /* Top/left values mimic padding */\n                top: 6px;\n                left: 6px;\n                width: 45%;\n                padding-right: 10px;\n                white-space: nowrap;\n            }\n\n            /*\n          Label the data\n          */\n            th:nth-of-type(1):before {\n                content: \"Date/Time\";\n            }\n            th:nth-of-type(2):before {\n                content: \"Requester\";\n            }\n            th:nth-of-type(3):before {\n                content: \"Reason\";\n            }\n            th:nth-of-type(4):before {\n                content: \"Status\";\n            }\n            th:nth-of-type(5):before {\n                content: \"Description\";\n            }\n            th:nth-of-type(6):before {\n                content: \"Notes\";\n            }\n        }\n    }\n}\n\n.modal__tables {\n    color: \"#4d4d4d\";\n    border: \"1px solid #4d4d4d\";\n    border-collapse: \"collapse\";\n    width: \"100%\";\n    table-layout: \"fixed\";\n    td {\n        text-align: center;\n    }\n    tr {\n        &:nth-child(even) {\n            background-color: #f2f2f2;\n        }\n    }\n    @media (max-width: $mobile) {\n        tbody {\n            tr {\n                td {\n                    word-break: break-all;\n                }\n            }\n        }\n    }\n}\n\n.driveoffRequests {\n    height: 80vh;\n    #content {\n        .overlay {\n            --border-style: 3px solid red;\n            --border-space: 20px;\n            margin-left: -40%;\n            position: absolute;\n            width: 88vw;\n            height: 80vh;\n        }\n\n        .overlay-helper {\n            position: relative;\n            width: 100%;\n            height: 100%;\n        }\n\n        .overlay-element {\n            padding: 20px;\n            width: 150px;\n            height: 100px;\n            position: absolute;\n        }\n\n        .overlay-text {\n            font-size: 1.75em;\n            color: black;\n            font-family: monospace;\n        }\n\n        .overlay .top-left {\n            border-left: var(--border-style);\n            border-top: var(--border-style);\n            top: var(--border-space);\n            left: var(--border-space);\n            text-align: left;\n        }\n\n        .overlay .top-right {\n            border-right: var(--border-style);\n            border-top: var(--border-style);\n            top: var(--border-space);\n            right: var(--border-space);\n            text-align: right;\n        }\n\n        .overlay .bottom-left {\n            border-left: var(--border-style);\n            border-bottom: var(--border-style);\n            bottom: var(--border-space);\n            left: var(--border-space);\n            text-align: left;\n        }\n\n        .overlay .bottom-right {\n            border-right: var(--border-style);\n            border-bottom: var(--border-style);\n            bottom: var(--border-space);\n            right: var(--border-space);\n            text-align: right;\n        }\n\n        #overlay-bottom-left-text {\n            position: absolute;\n            bottom: var(--border-space);\n            left: var(--border-space);\n        }\n\n        #overlay-bottom-right-text {\n            position: absolute;\n            bottom: var(--border-space);\n            right: var(--border-space);\n        }\n    }\n\n    .all_modals {\n        input[type=\"text\"] {\n            margin-bottom: 2%;\n            border: 1px solid $nitroDark;\n            border-radius: 0.5rem;\n            background-color: #fff;\n            width: 95%;\n            padding: 1%;\n        }\n    }\n\n    .all_modals {\n        input[type=\"text\"] {\n            margin-bottom: 2%;\n            border: 1px solid $nitroDark;\n            border-radius: 0.5rem;\n            background-color: #fff;\n            width: 95%;\n            padding: 1%;\n        }\n    }\n}\n\n.pending_driveoff_notif{\n  position: relative;\n  top: -50px;\n  right: -550px;\n  text-align: center;\n}\n.pending_driveoff_notif :hover{\n  cursor: pointer;\n  border: 2px solid black;\n}\n.notif_sub_level {\n    position: relative;\n    display: inline-block;\n}\n.span_notif_sub {\n    position: absolute;\n    top: -10px;\n    right: -25px;\n    background: rgba(20, 47, 201, 0.85);\n    color: white;\n    border-block: 50%;\n    padding: 2px 15px;\n    font-size: 25px;\n  }\n\n  .highlighted-row{\n    background-color: orange !important;\n  }\n  .pendingDriveoffModal{\n    overflow-y: scroll;\n    height: 80%;\n   .DriveoffModalTableHead{\n    background-color: rgb(231, 233, 236);\n    font-weight: bold;\n    } \n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
